import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';

import { CMSRenderEventsService } from '../../../render/services/cms-render-events.service';
import { ApiProductsList } from '../../_api/api-catalog/api-products/api-products.models';
import { ContextService } from '../../context/context.service';
import { Product } from '../products/products.models';
import { ProductsModelsTransformer } from '../products/products.models.transformer';
import { ProductsService } from '../products/products.service';


const MECACO_LOAD_PRODUCTS = 'cmsMecacoLoadProducts';

export interface MecacoServiceInterface {
  getMecacoProducts(sourceId: string, limit?: number): Observable<Product[]>;
}

@Injectable()
export class MecacoService implements MecacoServiceInterface {

  constructor(
    private readonly contextService: ContextService,
    private readonly productsService: ProductsService,
    private readonly cmsRenderEventsService: CMSRenderEventsService
  ) {}

  public getMecacoProducts(sourceId: string, limit?: number): Observable<Product[]> {
    return new Observable((observer) => {
      this.cmsRenderEventsService.emitEvent({
        name: MECACO_LOAD_PRODUCTS,
        type: 'load',
        data: { sourceId, limit: limit ?? 0 },
        callback: (loadedProducts) => {
          const productList = loadedProducts as ApiProductsList;

          this.contextService.getContext$().pipe(first()).subscribe((context) => {
            const products = ProductsModelsTransformer.productsFromApi(
              productList,
              context
            );

            this.productsService.addProductsToStore(products);

            observer.next(products);
          });
        }
      });
    });
  }

}
